module.exports = __webpack_public_path__ + "img/msg-icon.bf1ba021.svg";